<template>
	<div class="flex flex-col items-center">
		<LazyImage
			:src="src"
			:alt="`${collection} | ${name}`"
			class="aspect-square w-24"
			:preloader="preloader"
		/>
		<div
			class="text-label-secondary mt-4 truncate text-center text-xs font-medium uppercase"
		>
			{{ collection }}
		</div>
		<div
			class="mt-0.5 truncate text-center text-sm font-medium uppercase"
			:class="{
				'text-white': !color,
				'text-orange': color === 'orange',
				'text-pink-dark': color === 'red',
				'text-pink': color === 'pink',
				'text-blue': color === 'blue'
			}"
		>
			{{ name }}
		</div>
		<CoinPrice class="mt-2" :price="price" />
		<slot />
	</div>
</template>
<script setup lang="ts">
import CoinPrice from './CoinPrice.vue'
import LazyImage from './LazyImage.vue'

defineProps<{
	preloader?: string
	collection: string
	name: string
	color?: 'red' | 'orange' | 'blue' | 'pink'
	src: string
	price: number
}>()
</script>
